<template>
    <div class="jetlympic-popular">
      <div class="header">
        <div class="title flex-center">
            <div>热门比赛</div>
            <div class="icon"><van-icon name="bar-chart-o" />{{ liveBroadcastingCount }}场比赛直播中</div>
        </div>
        <div class="tabs">
          <van-tabs v-model="active" title-active-color="#00AAFF" color="#00AAFF" @change="onTabChange">
            <van-tab v-for="tab in tabs" :key="tab.value" :title="tab.name"></van-tab>
          </van-tabs>
        </div>
      </div>
      <div style="height: calc(100vh - 100px);">
      <van-list v-model="loading" :finished="finished" @load="getOrganizationLiveGameList">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id" @click="goLive(item)">
          <div class="cover">
            <img :src="imageView(item.livePoster || item.backgroundImage2)" />
            <div class="type" :class="item.liveStatus === 0 ? 'lookBack' : 'live'">
              <span v-if="item.liveStatus === 1">即将直播</span>
              <span v-if="item.liveStatus === 2">直播中</span>
              <span v-if="item.liveStatus === 0">回看</span>
            </div>
          </div>
          <div class="title overflow-text">{{ item.liveStatus === 1 ? '正播' : '' }} {{ item.group }} {{ item.matchName }}</div>
          <div class="vs overflow-text">
            <span v-if="item.homeAlias">{{ item.homeAlias}} </span>
            <span v-else>{{ item.homeTeamName }}</span>
            <span>对</span>
            <span v-if="item.awayAlias">{{ item.awayAlias}}</span>
            <span v-else>{{ item.awayTeamName }}</span>
          </div>
        </div>
      </div>
      </van-list>
      </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Icon, Tabs, Tab, List } from 'vant';
Vue.use(Tabs).use(Tab).use(Icon).use(List);
import { getOrganizationLiveGameList } from '@/api/match';
import { QNImageUtil } from "@/utils";
export default {
    data() {
    return {
          accountId: '',
          active: 0,
          tabs: [
            { name: this.$t(`jetlympic.sportType.全部`), value: '' },
            { name: this.$t(`jetlympic.sportType.篮球`), value: '篮球' },
            { name: this.$t(`jetlympic.sportType.足球`), value: '足球' },
            { name: this.$t(`jetlympic.sportType.羽毛球`), value: '羽毛球' },
            { name: this.$t(`jetlympic.sportType.乒乓球`), value: '乒乓球' }
          ],
          list: [],
          loading: false,
          finished: false,
          pageNum: 1,
          pageSize: 10,
          liveBroadcastingCount: 0
        };
  },
  mounted() {
    this.accountId = this.$route.query.accountId;
      // this.getOrganizationLiveGameList();
    },
  methods: {
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.originView(img)
    },
    getOrganizationLiveGameList() {
      const params = {
        accountId: this.accountId,
        sportType: this.tabs[this.active].value,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      getOrganizationLiveGameList(params).then(res => {
        const { data } = res
        this.liveBroadcastingCount = data.liveBroadcastingCount
        const list = data.list || []
        if (list.length < this.pageSize) {
          this.finished = true
        }
        this.pageNum++
        this.loading = false
        this.list.push(...list)
      })
    },
    onTabChange() {
      this.list = []
      this.pageNum = 1
      this.finished = false
      this.getOrganizationLiveGameList()
    },
    goLive(item) {
      if (item.liveStatus === 2) {
        if (process.env.NODE_ENV === 'development') {
          window.location.href = `https://www.snsports.cn/webapp-bmb-stage/index.html#/game1/${item.id}/videoList`
        } else {
          window.location.href = `https://www.snsports.cn/webapp-bmb/index.html#/game1/${item.id}/videoList`
        }
      } else {
        this.$router.push({ path: '/event/activity', query: { gameId: item.id } })
      }
    },
  }
};
</script>

<style scoped lang="scss">
.jetlympic-popular{
  .header{
    // 
    .title{
      height: 50px;
      padding: 0 16px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
      .icon{
        font-size: 12px;
        color: #00AAFF;
      }
    }
    .tabs{
      border-bottom: 1px solid #eee;
    }
  }
  .list{
    padding: 14px 12px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item{
      width: 170px;
      margin-bottom: 14px;
      .cover{
        position: relative;
        width: 170px;
        height: 97px;
        border-radius: 5px;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
        }
        .type{
          position: absolute;
          top: 0;
          right: 0;
          color: #fff;
          font-size: 10px;
          min-width: 40px;
          height: 18px;
          text-align: center;
          line-height: 18px;
          &.lookBack{
            background-color: #00AAFF;
          }
          &.live{
            background-color: #D54F3F;
          }
        }
      }
      .title{
        font-size: 15px;
        color: #303133;
        margin-top: 6px;
      }
      .vs{
        margin-top: 4px;
        font-size: 12px;
        color: #909399;
      }
    }
  }
}
</style>
